<script>
import Modal from "@/components/_Shared/Modal";
import vDialog from "@/components/_Shared/Dialog";
import RescheduleDialog from "@/components/Freshdesk/Absence/Reschedule/Reschedule";
import SuccessDialog from "@/components/Freshdesk/Success/Success";
import RescheduleTodayDialog from "@/components/Freshdesk/Absence/Reschedule/RescheduleToday";
import Why from "@/components/Freshdesk/Absence/Cancellation/Why";
import moment from "moment";

import freshdeskMixin from "@/mixins/freshdeskMixin";
import { mapActions } from "vuex";

export default {
  mixins: [freshdeskMixin],
  props: {
    order: Object,
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rescheduleDialogVisibility: false,
      successDialogVisibility: false,
      disableSendTicketButton: false,
      rescheduleTodayDialogVisibility: false,
      whyDialogVisibility: false,
      loader: false
    };
  },
  methods: {
    ...mapActions("freshdesk", ["createCreditHoursTicket", "setAbsence"]),
    availableSameDay() {
      let startsOrder = this.order.schedule_event.starts_at;
      return moment(startsOrder).isBefore(
        moment()
          .add(10, "hours")
          .startOf("day")
      );
    },
    closeOptionsDialog() {
      this.$emit("close");
    },
    openWhyDialog() {
      this.whyDialogVisibility = true;
    },
    closeWhyDialog() {
      this.whyDialogVisibility = false;
    },
    setTicketTags(order) {
      this.setCustomerTypeTag(order);
      this.setAdvanceTimeTag(order);
      this.isAbsenceTicket();
    },
    closeSuccessDialog() {
      this.successDialogVisibility = false;
    },
    async submit() {
      if (this.disableSendTicketButton) return;
      this.disableSendTicketButton = true;
      this.loader = true;
      this.setTicketTags(this.order);
      this.setAbsence(true);
      try {
        let payload = {
          order: this.order,
          tags: this.ticketTags
        };
        await this.createCreditHoursTicket(payload);
        this.successDialogVisibility = true;
        this.loader = false;
      } catch (e) {
        this.disableSendTicketButton = false;
        this.loader = false;
        this.$toasted.error(e);
      }
    }
  },
  components: {
    Modal,
    vDialog,
    RescheduleDialog,
    SuccessDialog,
    RescheduleTodayDialog,
    Why
  }
};
</script>


<template>
    <div>
          
        <modal 
            title="COMUNICAR FALTA DE PROFISSIONAL"
            size="md"
        >
            <template slot="body">
                <base-flex direction="column" class="mt-30">
                <div 
                  class="btn bg-purple" 
                  @click="rescheduleDialogVisibility=true"
                >prefiro reagendar a limpeza com outra profissional</div>

                <div 
                  class="btn bg-purple" 
                  :class="{'btn-disabled': availableSameDay()}"
                  @click="rescheduleTodayDialogVisibility=true"
                >prefiro verificar a possibilidade de reagendar para hoje</div>

                <div 
                  class="btn bg-purple" 
                  :class="{'btn--loading': loader}" 
                  :disabled="disableSendTicketButton"
                  @click="submit()"
                >{{ !loader ? "prefiro deixar o valor da limpeza como horas de crédito para uma proxima compra" : "Solicitando..." }}
                </div>

                <div 
                  class="btn bg-purple"
                  @click="openWhyDialog()"
                >prefiro receber o reembolso referente a esta limpeza</div>

                <div 
                  class="btn bg-purple-outline" 
                  @click="$emit('close')"
                >não quero prosseguir</div>
                </base-flex>
            <reschedule-dialog
              :order="order"
              v-if="rescheduleDialogVisibility"
              @close="rescheduleDialogVisibility = false; closeOptionsDialog()"
              @back="rescheduleDialogVisibility=false"
            />
            <reschedule-today-dialog
              :order="order"
              v-if="rescheduleTodayDialogVisibility"
              @close="rescheduleTodayDialogVisibility=false; closeOptionsDialog()"
              @back="rescheduleTodayDialogVisibility=false"
            />
            <why
              :order="order"
              v-if="whyDialogVisibility"
              @close="closeWhyDialog(); closeOptionsDialog()"
              @back="closeWhyDialog()"
            />
            <success-dialog 
              :visible="successDialogVisibility"
              @close="closeSuccessDialog(); closeOptionsDialog()"
            />
            </template>
        </modal>
    </div>
</template>

<style lang="scss" scoped>
.btn {
  border-radius: 10px;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 14px;
  width: 55%;
  @media (max-width: 768px) {
    font-size: 12px;
  }
}
.modal-title {
  @media (max-width: 768px) {
    font-size: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Freshdesk/Absence/Absence.vue